const COLORS = ['#ff1a2b', '#00f0ff'];

export default class MouseTrail {
  constructor() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      return;
    }

    this.last = 0;
    this.onMove = this.onMove.bind(this);

    window.addEventListener('mousemove', this.onMove);
  }

  onMove(e) {
    const now = performance.now();

    if (now - this.last < 35) {
      return;
    }

    this.last = now;

    const dot = document.createElement('div');
    const color = COLORS[Math.floor(Math.random() * COLORS.length)];

    dot.className = 'mouse-trail';
    dot.style.cssText = `left:${e.clientX - 4}px;top:${e.clientY - 4}px;--color:${color}`;
    document.body.appendChild(dot);

    requestAnimationFrame(() => dot.classList.add('is-fading'));
    setTimeout(() => dot.remove(), 520);
  }

  destroy() {
    window.removeEventListener('mousemove', this.onMove);
  }
}
